import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { StoreAuthorityScopeSnapshot } from '../../../../shared/models';

@Component({
  selector: 'app-store-authority-scope-list',
  templateUrl: './store-authority-scope-list.component.html',
  styleUrls: ['./store-authority-scope-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StoreAuthorityScopeListComponent {
  readonly scopes = input<StoreAuthorityScopeSnapshot[]>([]);
  readonly selectedCode = input<string>(null);
  readonly scopeSelected = output<StoreAuthorityScopeSnapshot>();

  select(scope: StoreAuthorityScopeSnapshot) {
    this.scopeSelected.emit(scope);
  }
}
